module.exports = __webpack_public_path__ + "img/marry-fit-plus-9.be604a15.png";